// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1Wyk9","info":"PatientInfo_info__2OaWc"};